import de from "../assets/locales/de/addressNameValues";
import en from "../assets/locales/en/addressNameValues";
import nl from "../assets/locales/nl/addressNameValues";

export function getAddressNameValues(country) {
    //FIX ME: rendere generico
    if (!country) {
        return en.values;
    }
    switch (country.toLowerCase()) {
        case "de":
        case "at":
            return de.values;
        case "en":
        case "uk":
            return en.values;
        case "nl":
            return nl.values;
        default:
            return en.values;
    }
}
